(() => {
  'use strict';

  if (window.__fbRaceWeekCountdown) return;
  window.__fbRaceWeekCountdown = true;

  const selector = '[data-fb-race-week]';
  const deadline = Date.parse('2026-10-08T12:00:00+02:00');
  let timerId = 0;

  const pad = (value) => String(value).padStart(2, '0');

  function update() {
    timerId = 0;
    const campaigns = document.querySelectorAll(selector);
    if (!campaigns.length) return;

    const remaining = Math.max(0, deadline - Date.now());
    if (remaining === 0) {
      campaigns.forEach((campaign) => {
        campaign.hidden = true;
      });
      document.dispatchEvent(new CustomEvent('fb:race-week-ended'));
      return;
    }

    const seconds = Math.floor(remaining / 1000);
    const values = {
      days: Math.floor(seconds / 86400),
      hours: Math.floor((seconds % 86400) / 3600),
      minutes: Math.floor((seconds % 3600) / 60),
      seconds: seconds % 60
    };

    campaigns.forEach((campaign) => {
      const countdown = campaign.querySelector('[data-fb-race-week-countdown]');
      if (!countdown) return;
      const days = countdown.querySelector('[data-fb-rw-days]');
      const hours = countdown.querySelector('[data-fb-rw-hours]');
      const minutes = countdown.querySelector('[data-fb-rw-minutes]');
      const secs = countdown.querySelector('[data-fb-rw-seconds]');
      if (days) days.textContent = String(values.days);
      if (hours) hours.textContent = pad(values.hours);
      if (minutes) minutes.textContent = pad(values.minutes);
      if (secs) secs.textContent = pad(values.seconds);
    });

    timerId = window.setTimeout(update, Math.max(100, 1000 - (Date.now() % 1000)));
  }

  function start() {
    if (timerId) window.clearTimeout(timerId);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
